import { render, staticRenderFns } from "./TestingArea.vue?vue&type=template&id=09633b94&scoped=true"
import script from "./TestingArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./TestingArea.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TestingArea.vue?vue&type=style&index=0&id=09633b94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09633b94",
  null
  
)

export default component.exports